<template>
  <v-app id="app" class="maxHeight">
    <v-dialog
      max-width="400"
      persistent
      transition="dialog-bottom-transition"
      v-model="updateApp"
    >
      <v-card class="mx-auto pa-3" dark>
        <v-card-title>
          <span class="title font-weight-bold">Nova versão disponível</span>
        </v-card-title>

        <v-card-text class="subheading font-weight-medium text-xs-justify">
          Por favor, atualize o aplicativo para continuar a utilização.
        </v-card-text>

        <v-card-actions>
          <v-layout align-center justify-end>
            <a
              :href="
                identifyAndroid()
                  ? 'https://play.google.com/store/apps/details?id=com.mobi.usecarfrotas'
                  : 'https://itunes.apple.com/br/app/usecar-frotas/id1546726677'
              "
            >
              <v-btn flat small>
                <span>IR PARA A LOJA</span>
              </v-btn>
            </a>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <router-view></router-view>
    <router-view :key="$route.fullPath" name="template"></router-view>

    <!-- <install-prompt /> -->
  </v-app>
</template>

<script>
import { setThemeColors } from './helpers/Theming';
import { routes } from './routes/routes.js';
import { createGtm } from 'vue-gtm';
import axios from 'axios';
import packageJsonValues from '../package.json';
export default {
  data() {
    return {
      routes,
      updateApp: false,
    };
  },
  async created() {
    await setThemeColors();
    this.gTagManager();
    this.verifyVersion();
  },
  metaInfo: {
    meta: [
      {
        charset: 'utf-8',
      },
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, shrink-to-fit=no',
      },
    ],
  },
  methods: {
    identifyAndroid() {
      if (navigator.userAgent.match(/Android/i)) {
        return true;
      } else {
        return false;
      }
    },
    verifyVersion() {
      axios
        .get(`${process.env.VUE_APP_API_ROOT_URL}/api/v1/public/version`)
        .then((res) => {
          let version_app = packageJsonValues.version
            .replace('.', '')
            .replace('.', '');
          let version_api = res.data.version.replace('.', '').replace('.', '');
          if (!(version_app >= version_api)) this.updateApp = true;
        });
    },
    gTagManager() {
      createGtm({
        id: 'GTM-TT27G9J',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.transparentBody {
  background: none transparent !important;
  background-color: none !important;
}
</style>
